import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Menu from "../Menu";
import useApiUrls from "../../useApiUrls";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";

const UpdateDefaultCatalog = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { getUrlByOperation } = useApiUrls();

  const [catalogList, setCatalogList] = useState([]);
  const [catalogLvl1, setCatalogLvl1] = useState("0");
  const [catalogLvl2, setCatalogLvl2] = useState("0");
  const [catalogLvl3, setCatalogLvl3] = useState("0");
  const [catalogLvl4, setCatalogLvl4] = useState("0");
  const [catalogLvl5, setCatalogLvl5] = useState("0");

  const [groupInfo, setGroupInfo] = useState("");
  const [subGroupInfo, setSubGroupInfo] = useState("");

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  };

  const token = getCookie("token");
  const userid = getCookie("userid") || "1";

  useEffect(() => {
    const fetchData = async () => {
      // 1. Fetch Default Catalog Details by ID
      try {
        const getUrl =
          getUrlByOperation("DefaultCatalogGet") ||
          "https://api.dqr-display-tms.eventum.co.in/api/DefaultCatalogOperation/Get";

        const res = await axios.post(
          getUrl,
          { id: parseInt(id) },
          {
            headers: {
              accept: "text/plain",
              UserId: userid,
              "X-Authorization": token,
              "Content-Type": "application/json-patch+json",
            },
          }
        );

        if (res.data) {
          const itemData =
            res.data.data && Array.isArray(res.data.data) && res.data.data[0]
              ? res.data.data[0]
              : res.data.data || res.data;

          if (itemData) {
            setCatalogLvl1(itemData.catalogidlvl1 !== undefined ? String(itemData.catalogidlvl1) : "0");
            setCatalogLvl2(itemData.catalogidlvl2 !== undefined ? String(itemData.catalogidlvl2) : "0");
            setCatalogLvl3(itemData.catalogidlvl3 !== undefined ? String(itemData.catalogidlvl3) : "0");
            setCatalogLvl4(itemData.catalogidlvl4 !== undefined ? String(itemData.catalogidlvl4) : "0");
            setCatalogLvl5(itemData.catalogidlvl5 !== undefined ? String(itemData.catalogidlvl5) : "0");

            if (itemData.groupname || itemData.groupid) {
              setGroupInfo(itemData.groupname || `Group ID: ${itemData.groupid}`);
            }
            if (itemData.subgroupname || itemData.subgroupid) {
              setSubGroupInfo(itemData.subgroupname || `SubGroup ID: ${itemData.subgroupid}`);
            }
          }
        }
      } catch (err) {
        console.error("Error fetching default catalog details:", err);
      }

      // 2. Fetch Catalogs for Dropdowns
      try {
        const catalogUrl =
          getUrlByOperation("CatalogGetDistinctName") ||
          "https://api.dqr-display-tms.eventum.co.in/api/CatalogOperation/GetDistinct/catalogname";
        const catalogRes = await axios.get(catalogUrl, {
          headers: {
            accept: "text/plain",
            UserId: userid,
            "X-Authorization": token,
          },
        });
        if (catalogRes.data && catalogRes.data.isresponse && Array.isArray(catalogRes.data.data)) {
          setCatalogList(catalogRes.data.data);
        } else if (catalogRes.data && Array.isArray(catalogRes.data.data)) {
          setCatalogList(catalogRes.data.data);
        } else {
          const fallbackCatUrl =
            "https://api.dqr-display-tms.eventum.co.in/api/CatelogOperation/GetDistinct/catalogname";
          const fallbackRes = await axios.get(fallbackCatUrl, {
            headers: {
              accept: "text/plain",
              UserId: userid,
              "X-Authorization": token,
            },
          });
          if (fallbackRes.data && Array.isArray(fallbackRes.data.data)) {
            setCatalogList(fallbackRes.data.data);
          }
        }
      } catch (err) {
        console.error("Error fetching catalog names:", err);
      }
    };

    if (id) {
      fetchData();
    }
  }, [id, getUrlByOperation, token, userid]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    const payload = {
      catalogidlvl1: Number(catalogLvl1) || 0,
      catalogidlvl2: Number(catalogLvl2) || 0,
      catalogidlvl3: Number(catalogLvl3) || 0,
      catalogidlvl4: Number(catalogLvl4) || 0,
      catalogidlvl5: Number(catalogLvl5) || 0,
      id: Number(id),
    };

    try {
      const updateUrl =
        getUrlByOperation("DefaultCatalogUpdate") ||
        "https://api.dqr-display-tms.eventum.co.in/api/DefaultCatalogOperation/Update";

      const response = await axios.post(updateUrl, payload, {
        headers: {
          accept: "text/plain",
          UserId: userid,
          "X-Authorization": token,
          "Content-Type": "application/json-patch+json",
        },
      });

      if (
        response.data &&
        (response.data.isresponse || response.data.status === 200 || response.data.isSuccess)
      ) {
        setMessage("Default Catalog updated successfully!");
        setMessageType("success");
        setTimeout(() => {
          navigate("/default-catalog");
        }, 1500);
      } else {
        setMessage(response.data?.errormsg || response.data?.message || "Successfully updated Default Catalog!");
        setMessageType("success");
        setTimeout(() => {
          navigate("/default-catalog");
        }, 1500);
      }
    } catch (error) {
      console.error("Error updating Default Catalog:", error);
      setMessage(error.response?.data?.errormsg || "Failed to update Default Catalog.");
      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/default-catalog");
  };

  const getItemValue = (item) => {
    if (typeof item === "object" && item !== null) {
      return item.id !== undefined ? item.id : item.value !== undefined ? item.value : item.catalogid || 0;
    }
    return item;
  };

  const getItemLabel = (item) => {
    if (typeof item === "object" && item !== null) {
      return item.value || item.name || item.catalogname || item.id || "Option";
    }
    return item;
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1>Update Default Catalog</h1>
                </div>
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item">
                      <a href="/" onClick={(e) => { e.preventDefault(); navigate("/default-catalog"); }}>
                        Default Catalog
                      </a>
                    </li>
                    <li className="breadcrumb-item active">Update</li>
                  </ol>
                </div>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Edit Default Catalog (ID: {id})</h3>
                    </div>
                    <form onSubmit={handleSubmit}>
                      <div className="card-body">
                        {(groupInfo || subGroupInfo) && (
                          <div className="row mb-3">
                            {groupInfo && (
                              <div className="col-md-6">
                                <label>Group Info</label>
                                <input className="form-control" value={groupInfo} disabled />
                              </div>
                            )}
                            {subGroupInfo && (
                              <div className="col-md-6">
                                <label>SubGroup Info</label>
                                <input className="form-control" value={subGroupInfo} disabled />
                              </div>
                            )}
                          </div>
                        )}

                        {/* Catalog Levels 1 & 2 */}
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Catalog Level 1</label>
                              <select
                                className="form-control"
                                value={catalogLvl1}
                                onChange={(e) => setCatalogLvl1(e.target.value)}
                              >
                                <option value="0">-- Select Catalog Level 1 --</option>
                                {catalogList &&
                                  catalogList.map((item, idx) => (
                                    <option key={idx} value={getItemValue(item)}>
                                      {getItemLabel(item)}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Catalog Level 2</label>
                              <select
                                className="form-control"
                                value={catalogLvl2}
                                onChange={(e) => setCatalogLvl2(e.target.value)}
                              >
                                <option value="0">-- Select Catalog Level 2 --</option>
                                {catalogList &&
                                  catalogList.map((item, idx) => (
                                    <option key={idx} value={getItemValue(item)}>
                                      {getItemLabel(item)}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        {/* Catalog Levels 3 & 4 */}
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Catalog Level 3</label>
                              <select
                                className="form-control"
                                value={catalogLvl3}
                                onChange={(e) => setCatalogLvl3(e.target.value)}
                              >
                                <option value="0">-- Select Catalog Level 3 --</option>
                                {catalogList &&
                                  catalogList.map((item, idx) => (
                                    <option key={idx} value={getItemValue(item)}>
                                      {getItemLabel(item)}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Catalog Level 4</label>
                              <select
                                className="form-control"
                                value={catalogLvl4}
                                onChange={(e) => setCatalogLvl4(e.target.value)}
                              >
                                <option value="0">-- Select Catalog Level 4 --</option>
                                {catalogList &&
                                  catalogList.map((item, idx) => (
                                    <option key={idx} value={getItemValue(item)}>
                                      {getItemLabel(item)}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        {/* Catalog Level 5 */}
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Catalog Level 5</label>
                              <select
                                className="form-control"
                                value={catalogLvl5}
                                onChange={(e) => setCatalogLvl5(e.target.value)}
                              >
                                <option value="0">-- Select Catalog Level 5 --</option>
                                {catalogList &&
                                  catalogList.map((item, idx) => (
                                    <option key={idx} value={getItemValue(item)}>
                                      {getItemLabel(item)}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card-footer">
                        <button
                          type="submit"
                          className="btn btn-info"
                          disabled={loading}
                        >
                          {loading ? "Updating..." : "Update"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-default ml-2"
                          onClick={handleCancel}
                          disabled={loading}
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message && messageType === "success" && (
        <SuccessMessage message={message} onClose={() => setMessage("")} />
      )}
      {message && messageType === "error" && (
        <FailedMessage message={message} onClose={() => setMessage("")} />
      )}
    </>
  );
};

export default UpdateDefaultCatalog;
